import type { StateCreator } from 'zustand';

export interface ContextSwitchImage {
  src: string;
  fallbackSrc: string;
}

export interface ContextSwitchState {
  contextSwitch: ContextSwitchImage | null;
  startContextSwitch: (image: ContextSwitchImage) => void;
  finishContextSwitch: (image: ContextSwitchImage) => void;
}

export const createContextSwitchSlice: StateCreator<ContextSwitchState> = (
  set
) => ({
  contextSwitch: null,
  startContextSwitch: (image) => set({ contextSwitch: image }),
  // A previous transition's completion must never dismiss a newer one.
  finishContextSwitch: (image) =>
    set((state) =>
      state.contextSwitch === image ? { contextSwitch: null } : state
    ),
});
